module.exports = __webpack_public_path__ + "static/img/open-cart.997ddfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/open-cart.png
// module id = LyJj
// module chunks = 0 139